import { AnalyticsEvent } from '../types';
import apiService from '../../../services/api';

class SalesAnalytics {
  private enabled: boolean = true;

  constructor() {
    // Check if analytics is enabled (could be from user preferences)
    this.enabled = localStorage.getItem('analytics_enabled') !== 'false';
  }

  track(event: AnalyticsEvent) {
    if (!this.enabled) return;

    try {
      // Send to Google Analytics if available
      if (typeof window !== 'undefined' && (window as any).gtag) {
        (window as any).gtag('event', event.action, {
          event_category: event.category,
          event_label: event.label,
          value: event.value,
          ...event.metadata
        });
      }

      // Send to backend for analysis
      apiService.trackEvent?.(event).catch((error) => {
        console.warn('Failed to track event:', error);
      });
    } catch (error) {
      console.warn('Analytics error:', error);
    }
  }

  trackProductView(productId: number) {
    this.track({
      event: 'product_view',
      category: 'product',
      action: 'view',
      label: `product_${productId}`
    });
  }

  trackProductCreate() {
    this.track({
      event: 'product_create',
      category: 'product',
      action: 'create'
    });
  }

  trackProductEdit(productId: number) {
    this.track({
      event: 'product_edit',
      category: 'product',
      action: 'edit',
      label: `product_${productId}`
    });
  }

  trackProductDelete(productId: number) {
    this.track({
      event: 'product_delete',
      category: 'product',
      action: 'delete',
      label: `product_${productId}`
    });
  }



  trackCrossSellClick(recommendedProductId: number, triggerProductIds: number[]) {
    this.track({
      event: 'cross_sell_click',
      category: 'sales',
      action: 'cross_sell_interaction',
      label: `recommended_${recommendedProductId}`,
      metadata: {
        trigger_products: triggerProductIds
      }
    });
  }

  trackCrossSellAdd(recommendedProductId: number, triggerProductIds: number[]) {
    this.track({
      event: 'cross_sell_add',
      category: 'sales',
      action: 'cross_sell_add',
      label: `recommended_${recommendedProductId}`,
      metadata: {
        trigger_products: triggerProductIds
      }
    });
  }

  trackSaleStarted() {
    this.track({
      event: 'sale_started',
      category: 'sales',
      action: 'start'
    });
  }

  trackSaleStepCompleted(step: number, stepName: string) {
    this.track({
      event: 'sale_step_completed',
      category: 'sales',
      action: 'step_complete',
      label: stepName,
      value: step
    });
  }

  trackSaleCompleted(saleData: {
    productCount: number;
    crossSellCount: number;
    totalCommission: number;
    duration: number; // in seconds
  }) {
    this.track({
      event: 'sale_completed',
      category: 'sales',
      action: 'complete',
      value: saleData.totalCommission,
      metadata: {
        product_count: saleData.productCount,
        cross_sell_count: saleData.crossSellCount,
        has_cross_sell: saleData.crossSellCount > 0,
        duration: saleData.duration
      }
    });
  }

  trackSaleAbandoned(step: number, stepName: string) {
    this.track({
      event: 'sale_abandoned',
      category: 'sales',
      action: 'abandon',
      label: stepName,
      value: step
    });
  }

  enable() {
    this.enabled = true;
    localStorage.setItem('analytics_enabled', 'true');
  }

  disable() {
    this.enabled = false;
    localStorage.setItem('analytics_enabled', 'false');
  }
}

export const salesAnalytics = new SalesAnalytics();
export default salesAnalytics;



